import { render, staticRenderFns } from "./ScheduledMessageList.vue?vue&type=template&id=238d0d12&scoped=true&lang=pug"
import script from "./ScheduledMessageList.vue?vue&type=script&lang=ts"
export * from "./ScheduledMessageList.vue?vue&type=script&lang=ts"
import style0 from "./ScheduledMessageList.vue?vue&type=style&index=0&id=238d0d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d0d12",
  null
  
)

export default component.exports